/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import Image from "next/image";
import { useState, useEffect } from "react";
import { useParams } from "next/navigation";
import { useBitKeepDetection } from "@/hooks/useBitKeepDetection";
import { useBitKeepContext } from "@/components/BitKeepProvider";
import { tracker } from "@/track";
// components
import AppOpenBanner from "@/components/AppOpenBanner";
import Button from "@/components/basic/Button";
const SelectToken = lazy(()=>import("./selectToken"));
const SwapHistory = lazy(()=>import("./SwapHistory"));
const SwapResult = lazy(()=>import("./SwapResult"));
// wallet
import { useWallet } from "@/wallet";
import { useToast } from "@/ui/toast/use-toast";
// transaction
import { sol_buildTokenTransferTransaction } from "@/transaction/sol";
import { ton_buildTokenTransferTransaction } from "@/transaction/ton";
import { evm_buildTokenTransferTransaction } from "@/transaction/evm";
// utils
import { openSafeWindow } from "@bit/utils";
import { formatAddress, ErrorMessage } from "@/utils/common";
import { subtract, multiply } from "@/decimal/math";
import { floor } from "@/decimal/round";
import bs58 from "bs58";
//stores
import { useGlobalStore } from "@/stores/global";
// assets
import { CommonImages } from "../assets/images";
// swap token 币种信息
import { TokenList, toTokenList } from "../config/tokenInfo";
// apis
import { getExchangeConfig, listExchangeOrder, exchangeOrderSend, evmAndTonExchangeOrderSend } from "@/apis/bwbSwapBgb";
import { batchV2, getComputeFeePrice } from "@/apis/wallet";
import FAQ from "./FAQ";
import TutorialLink from "./TutorialLink";
const configInfo = {
    EXCHANGE_RATE: 0,
    BWB_MINI_AMOUNT_PRE_TX: 0,
    BWB_MAX_AMOUNT_PRE_TX: 0,
    BGB_SEND_GAS_ETH: 0,
    BGB_SEND_GAS_MORPH: 0,
    supportList: [],
    bgbEthAmount: 0,
    bgbMorphAmount: 0
};
const walletInfoInit = {
    headPic: "",
    walletAddress: {},
    walletAvatarUrl: "",
    walletId: "",
    walletName: "wallet Name",
    walletType: ""
};
const SwapContent = ()=>{
    const { locale = "en" } = useParams();
    const { token, chainObj, appHeaderReady } = useGlobalStore();
    const t = useTranslations("");
    const isBitkeep = useBitKeepDetection();
    const { bitkeep, isReady, error } = useBitKeepContext();
    const { connect, sendTransaction, switchChain, address, chainType } = useWallet();
    const { toast } = useToast();
    //设置初始字段状态
    const [EventData, setEventData] = useState({
        address: "",
        channel_af: "bwbSwapBgb",
        system_language: locale,
        wallet_tag: "",
        wallet_type: ""
    });
    const [isInputFocused, setIsInputFocused] = useState(false);
    const [isButtonLoading, setIsButtonLoading] = useState(false);
    const [isloading, setLoading] = useState(true);
    const [selectTokenType, setSelectTokenType] = useState("from");
    const [WalletInfo, setWalletInfo] = useState(walletInfoInit);
    const [fromAddress, setfromAddress] = useState(null);
    const [toAddress, settoAddress] = useState("");
    const [fromTokenList, setfromTokenList] = useState(TokenList);
    const [fromToken, setfromToken] = useState(fromTokenList[2]);
    const [toToken, settoToken] = useState(toTokenList[1]);
    const [bwbAmount, setbwbAmount] = useState("0");
    // const [receiveAmount, setReceiveAmount] = useState<string>('0');
    const [exchangeConfig, setExchangeConfig] = useState(configInfo);
    const [isOpenselectToken, setIsOpenselectToken] = useState(false);
    const [isOpenSwapHistory, setIsOpenSwapHistory] = useState(false);
    const [swapResultStatus, setSwapResultStatus] = useState("success");
    const [isOpenSwapResult, setIsOpenSwapResult] = useState(false);
    const [switchCount, setSwitchCount] = useState(0);
    const [records, setRecords] = useState([]);
    const [priorityFee, setPriorityFee] = useState(30000);
    const reloadData = async ()=>{
        getbwbBalance(chainObj);
        getlistExchangeOrder({
            address: (chainObj === null || chainObj === void 0 ? void 0 : chainObj.eth) || (chainObj === null || chainObj === void 0 ? void 0 : chainObj.bnb) || (chainObj === null || chainObj === void 0 ? void 0 : chainObj.morph),
            page: 1,
            limit: 1000
        });
    };
    const [validationState, setValidationState] = useState({
        isValid: true,
        errorKey: null,
        errorParams: {}
    });
    const clearValidation = ()=>{
        setValidationState({
            isValid: true,
            errorKey: null,
            errorParams: {}
        });
    };
    const exchangeRate = useMemo(()=>{
        const amount = Number(exchangeConfig === null || exchangeConfig === void 0 ? void 0 : exchangeConfig.EXCHANGE_RATE);
        // 检查是否为有效数字且不为 NaN
        return !isNaN(amount) ? amount : 0; // 处理边界情况，确保不小于0
    }, [
        exchangeConfig === null || exchangeConfig === void 0 ? void 0 : exchangeConfig.EXCHANGE_RATE
    ]);
    const maxAmountPerTx = useMemo(()=>{
        const amount = Number(exchangeConfig === null || exchangeConfig === void 0 ? void 0 : exchangeConfig.BWB_MAX_AMOUNT_PRE_TX);
        // 检查是否为有效数字且不为 NaN
        return !isNaN(amount) ? amount : 0; // 处理边界情况，确保不小于0
    }, [
        exchangeConfig === null || exchangeConfig === void 0 ? void 0 : exchangeConfig.BWB_MAX_AMOUNT_PRE_TX
    ]);
    const minAmountPerTx = useMemo(()=>{
        const amount = Number(exchangeConfig === null || exchangeConfig === void 0 ? void 0 : exchangeConfig.BWB_MINI_AMOUNT_PRE_TX);
        // 检查是否为有效数字且不为 NaN
        return !isNaN(amount) ? amount : 0; // 处理边界情况，确保不小于0
    }, [
        exchangeConfig === null || exchangeConfig === void 0 ? void 0 : exchangeConfig.BWB_MINI_AMOUNT_PRE_TX
    ]);
    const maxLiquid = useMemo(()=>{
        try {
            let amount = 0;
            if (toToken.chain === "eth") {
                amount = Number(exchangeConfig === null || exchangeConfig === void 0 ? void 0 : exchangeConfig.bgbEthAmount);
            }
            if (toToken.chain === "morph") {
                amount = Number(exchangeConfig === null || exchangeConfig === void 0 ? void 0 : exchangeConfig.bgbMorphAmount);
            }
            if (isNaN(amount) || isNaN(exchangeRate) || exchangeRate == 0) {
                return 0; // 确保有效的数字
            }
            const liquidValue = (amount / exchangeRate).toFixed(2);
            return liquidValue;
        } catch (error) {
            console.log("maxLiquid calculate error", error);
        }
        return "0.00"; // 返回字符串格式的默认值
    }, [
        exchangeRate,
        exchangeConfig === null || exchangeConfig === void 0 ? void 0 : exchangeConfig.bgbEthAmount,
        toToken.chain
    ]);
    // const maxLimitAmount = useMemo(() => {
    //   const fromBalance = Number(fromToken?.balance);
    //   const liquidAmount = Number(maxLiquid);
    //   // 检查有效性，确保所有值都是有效数字
    //   const values = [maxAmountPerTx, fromBalance, liquidAmount].filter(value => !isNaN(value));
    //   return values.length > 0 ? Math.min(...values) : 0; // 如果没有有效值，返回0
    // }, [maxAmountPerTx, fromToken?.balance, maxLiquid]);
    const receiveAmount = useMemo(()=>{
        try {
            const numericValue = parseFloat(bwbAmount);
            if (!isNaN(numericValue)) {
                return multiply(numericValue, exchangeRate);
            } else {
                return "0"; // 默认值
            }
        } catch (error) {
            console.error("numericValue", error);
            return "0";
        }
    }, [
        bwbAmount,
        fromToken === null || fromToken === void 0 ? void 0 : fromToken.chain,
        exchangeRate
    ]);
    const bwbAmountNumber = useMemo(()=>{
        const amount = Number(bwbAmount);
        // 检查是否为有效数字且不为 NaN
        return !isNaN(amount) && amount >= 0 ? amount : 0; // 处理边界情况，确保不小于0
    }, [
        bwbAmount
    ]);
    const receiveAmountNumber = useMemo(()=>{
        const amount = Number(receiveAmount);
        // 检查是否为有效数字且不为 NaN
        const result = !isNaN(amount) && amount >= 0 ? amount : 0; // 处理边界情况，确保不小于0
        return result;
    }, [
        receiveAmount
    ]);
    // 验证函数
    const validateInput = useMemo(()=>{
        return (amount)=>{
            // 记录验证过程
            const validationSteps = [];
            // 验证输入是否为有效数字
            const numericValue = Number(amount);
            if (isNaN(numericValue) || numericValue < 0) {
                validationSteps.push({
                    step: "input_validation",
                    isValid: false,
                    value: amount
                });
                return {
                    isValid: false,
                    errorKey: null,
                    steps: validationSteps
                };
            }
            //  验证余额
            const balance = Number(fromToken === null || fromToken === void 0 ? void 0 : fromToken.balance);
            if (numericValue > balance) {
                validationSteps.push({
                    step: "balance",
                    isValid: false,
                    value: numericValue,
                    balance: balance
                });
                return {
                    isValid: false,
                    errorKey: "insufficientBalance",
                    steps: validationSteps
                };
            }
            // 验证最小交易额
            if (numericValue < minAmountPerTx) {
                validationSteps.push({
                    step: "min_amount",
                    isValid: false,
                    value: numericValue,
                    limit: minAmountPerTx
                });
                return {
                    isValid: false,
                    errorKey: "minSellAmount",
                    errorParams: {
                        num: minAmountPerTx
                    },
                    steps: validationSteps
                };
            }
            //  验证最大交易额
            if (numericValue > maxAmountPerTx) {
                validationSteps.push({
                    step: "max_amount",
                    isValid: false,
                    value: numericValue,
                    limit: maxAmountPerTx
                });
                return {
                    isValid: false,
                    errorKey: "maxSellAmount",
                    errorParams: {
                        num: maxAmountPerTx
                    },
                    steps: validationSteps
                };
            }
            // 验证兑换额度
            const liquidAmount = Number(maxLiquid);
            if (liquidAmount == 0 || numericValue > liquidAmount) {
                validationSteps.push({
                    step: "quota",
                    isValid: false,
                    value: numericValue,
                    liquidAmount: liquidAmount
                });
                return {
                    isValid: false,
                    errorKey: "quotaExhausted",
                    errorParams: {
                        coin: toToken.symbol
                    },
                    steps: validationSteps
                };
            }
            // 所有验证通过
            return {
                isValid: true,
                errorKey: null,
                steps: validationSteps
            };
        };
    }, [
        minAmountPerTx,
        maxAmountPerTx,
        fromToken === null || fromToken === void 0 ? void 0 : fromToken.balance,
        maxLiquid,
        toToken === null || toToken === void 0 ? void 0 : toToken.symbol
    ]);
    // Solana 优先费
    const SolanaComputeFeePrice = async ()=>{
        try {
            const res = await getComputeFeePrice.fetcher();
            const { data, status } = res;
            if (status == 0 && data) {
                if (data["15"]) {
                    const feeavg = Math.ceil(data["15"].avg);
                    const priorityFee = floor(feeavg * 1.2, 0);
                    setPriorityFee(priorityFee);
                } else {
                    setPriorityFee(300000);
                }
            }
        } catch (error) {
            console.log("SolanaComputeFeePrice error:", error);
        }
    };
    // sol 转账交易构建
    const solSign = async ()=>{
        /**
     * 自行构建交易
     */ // TODO: 从接口获取手续费
        try {
            const options = {
                priorityFee: priorityFee
            };
            // 构建交易
            const { transaction } = await sol_buildTokenTransferTransaction(fromAddress, fromToken.address, fromToken.contract, bwbAmountNumber, options);
            const signature = await sendTransaction("sol", transaction);
            const sig = bs58.encode(signature.serialize());
            const res = await exchangeOrderSend.fetcher({
                sig,
                chain: fromToken.chain,
                from: fromAddress,
                to: fromToken.address,
                contract: fromToken.contract,
                amount: bwbAmountNumber,
                toAddress: toAddress,
                toChain: toToken.chain,
                exchangeRate: exchangeConfig.EXCHANGE_RATE,
                bgbSendGas: toToken.chain == "eth" ? exchangeConfig === null || exchangeConfig === void 0 ? void 0 : exchangeConfig.BGB_SEND_GAS_ETH : exchangeConfig === null || exchangeConfig === void 0 ? void 0 : exchangeConfig.BGB_SEND_GAS_MORPH
            });
            const { data, status } = res;
            if (status == 0 && data.txid) {
                reloadData();
                setbwbAmount("0");
                setIsOpenSwapResult(true);
            } else {
                toast({
                    variant: "error",
                    title: data || "sol send server error",
                    duration: 3000
                });
                setSwapResultStatus("failed");
            }
            setIsButtonLoading(false);
        } catch (error) {
            const Message = error instanceof Error ? error.message : ErrorMessage(error);
            console.log("--------solSign Error-----------", Message);
            tracker.click("b10706", {
                ...EventData,
                dataid: "solSign",
                content: "------------solSign Error---------,".concat(Message)
            });
            toast({
                variant: "error",
                title: Message,
                duration: 3000
            });
            setSwapResultStatus("failed");
            setIsButtonLoading(false);
        }
    };
    //ton 转账交易构建
    const tonSign = async ()=>{
        try {
            const publicKey = address.publicKey;
            const rawAddress = address.raw;
            const toTokenAddress = fromToken.address;
            const contract = fromToken.contract;
            const tonBuildResult = await ton_buildTokenTransferTransaction(fromAddress, toAddress, toTokenAddress, contract, bwbAmountNumber, publicKey, "bwb");
            if (tonBuildResult.status != 0) {
                toast({
                    variant: "error",
                    title: tonBuildResult.data || "ton buildTransaction error",
                    duration: 3000
                });
                setIsButtonLoading(false);
                return;
            }
            const sendres = await sendTransaction("ton", [
                {
                    chain: "ton",
                    from: rawAddress,
                    network: "-239",
                    to: toTokenAddress,
                    valid_until: new Date().getTime() + 1000 * 60 * 10,
                    symbol: "bwb",
                    amount: Number(bwbAmountNumber) * 10 ** 9,
                    contract: contract,
                    publicKey: publicKey,
                    memo: toAddress,
                    messages: tonBuildResult.data.messages
                }
            ]);
            const res = await evmAndTonExchangeOrderSend.fetcher({
                sig: sendres === null || sendres === void 0 ? void 0 : sendres.boc,
                chain: fromToken.chain,
                from: fromAddress,
                to: toTokenAddress,
                contract: contract,
                amount: bwbAmountNumber,
                toAddress: toAddress,
                toChain: toToken.chain,
                exchangeRate: exchangeConfig.EXCHANGE_RATE,
                bgbSendGas: toToken.chain == "eth" ? exchangeConfig === null || exchangeConfig === void 0 ? void 0 : exchangeConfig.BGB_SEND_GAS_ETH : exchangeConfig === null || exchangeConfig === void 0 ? void 0 : exchangeConfig.BGB_SEND_GAS_MORPH,
                txid: sendres === null || sendres === void 0 ? void 0 : sendres.boc
            });
            const { data, status } = res;
            if (status == 0 && data.txid) {
                reloadData();
                setbwbAmount("0");
                setIsOpenSwapResult(true);
            } else {
                toast({
                    variant: "error",
                    title: data || "ton send server error",
                    duration: 3000
                });
                setSwapResultStatus("failed");
                console.log("------------ton_buildTokenTransfer send error---------", data);
            }
            setIsButtonLoading(false);
        } catch (error) {
            const Message = error instanceof Error ? error.message : ErrorMessage(error);
            tracker.click("b10706", {
                ...EventData,
                dataid: "tonSign",
                content: "------------tonSign Error---------,".concat(Message)
            });
            toast({
                variant: "error",
                title: Message,
                duration: 3000
            });
            console.log("------------tonSign Error---------", Message);
            setSwapResultStatus("failed");
            setIsButtonLoading(false);
        }
    };
    //evm 转账交易构建
    const EvmSign = async (chainId)=>{
        try {
            const toTokenAddress = fromToken.address;
            const contract = fromToken.contract;
            const transactionParameters = await evm_buildTokenTransferTransaction(fromAddress, toTokenAddress, contract, bwbAmountNumber, 18, chainId);
            // txHash is a hex string
            // As with any RPC call, it may throw an error
            const txHash = await sendTransaction("eth", transactionParameters);
            const res = await evmAndTonExchangeOrderSend.fetcher({
                sig: txHash,
                chain: fromToken.chain,
                from: fromAddress,
                to: fromToken.address,
                contract: fromToken.contract,
                amount: bwbAmountNumber,
                toAddress: toAddress,
                toChain: toToken.chain,
                exchangeRate: exchangeConfig.EXCHANGE_RATE,
                bgbSendGas: toToken.chain == "eth" ? exchangeConfig === null || exchangeConfig === void 0 ? void 0 : exchangeConfig.BGB_SEND_GAS_ETH : exchangeConfig === null || exchangeConfig === void 0 ? void 0 : exchangeConfig.BGB_SEND_GAS_MORPH,
                txid: txHash
            });
            const { data, status, msg } = res;
            if (status == 0 && data.txid) {
                reloadData();
                setbwbAmount("0");
                setIsOpenSwapResult(true);
            } else {
                toast({
                    variant: "error",
                    title: msg || "evm send server error",
                    duration: 3000
                });
                setSwapResultStatus("failed");
                console.log("evm_buildTokenTransfer send error", data);
            }
            setIsButtonLoading(false);
        } catch (error) {
            const Message = error instanceof Error ? error.message : ErrorMessage(error);
            console.log("------------EvmSign Error---------", Message);
            tracker.click("b10706", {
                ...EventData,
                dataid: "EvmSign",
                content: "------------EvmSign Error---------,".concat(Message)
            });
            toast({
                variant: "error",
                title: Message,
                duration: 3000
            });
            setIsButtonLoading(false);
            setSwapResultStatus("failed");
        }
    };
    // click 执行方法
    const handleOpenApp = ()=>{
        if (!isBitkeep) {
            const currentUrl = "https://bkcode.vip/?deep_link_value=bitkeep://webview?url=".concat(window.location.origin + window.location.pathname, "?_needChain=eth&_nocache=true");
            openSafeWindow(currentUrl, "_blank");
            return false;
        }
        return true;
    };
    const handleConnect = async (chain, init)=>{
        setIsButtonLoading(true);
        if (!handleOpenApp()) {
            return false;
        }
        if (!init) {
            if (!toAddress) {
                const { success, data } = await bitkeep.confirm(t("bwbSwap_walletError"));
                if (!success) {
                    bitkeep.close();
                }
                if (data == "true") {
                    switchWallet();
                } else {
                    bitkeep.close();
                }
                setIsButtonLoading(false);
                return;
            }
        }
        try {
            await connect(chain);
            if (chain == "eth" || chain == "base") {
                await switchChain(chain);
            }
            setSwitchCount((prev)=>prev + 1);
            setIsButtonLoading(false);
        } catch (err) {
            setIsButtonLoading(false);
            console.error("Connection failed:", err);
        }
    };
    const switchWallet = async ()=>{
        bitkeep.switchWallet("eth");
    };
    const openSelectToken = function() {
        let type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "from";
        if (!handleOpenApp()) {
            return false;
        }
        setSelectTokenType(type);
        setIsOpenselectToken(true);
    };
    const handleTokenSelect = (token)=>{
        if (!handleOpenApp()) {
            return false;
        }
        try {
            if (token.symbol == "BWB") {
                handleConnect(token.chain);
            } else {
                settoToken({
                    ...token
                });
                resetSwapData();
            }
            setIsOpenselectToken(false);
            setIsButtonLoading(false);
        } catch (error) {
            setIsButtonLoading(false);
            console.log("handleTokenSelect Error", error);
        }
    };
    const swap = ()=>{
        setIsButtonLoading(true);
        try {
            const swapChain = fromToken.chain;
            switch(swapChain){
                case "sol":
                    solSign();
                    break;
                case "base":
                case "eth":
                    EvmSign(fromToken.chainId);
                    break;
                case "ton":
                    tonSign();
                    break;
                default:
                    break;
            }
        } catch (error) {
            console.log("swapSign Error", error);
        }
    };
    const ExchangeConfig = async ()=>{
        try {
            const res = await getExchangeConfig.fetcher();
            const { data, status } = res;
            if (status == 0 && data) {
                setExchangeConfig({
                    ...data
                });
                const fromList = fromTokenList.map((token)=>{
                    const itemToken = data.supportList.filter((item)=>item.chain == token.chain);
                    if (itemToken[0]) {
                        return {
                            ...token,
                            contract: itemToken[0].contract,
                            address: itemToken[0].address
                        };
                    }
                    return null;
                }).filter(Boolean);
                setfromTokenList([
                    ...fromList
                ]);
                const selectChainIndex = chainType ? fromList.findIndex((item)=>item.chain === chainType) : 2;
                setfromToken({
                    ...fromList[selectChainIndex]
                });
                setLoading(false);
            } else {
                toast({
                    variant: "error",
                    title: data || "config server error",
                    duration: 3000
                });
            }
        } catch (error) {
            console.log("ExchangeConfig error:", error);
            setLoading(false);
        }
    };
    useEffect(()=>{
        (async ()=>{
            try {
                await Promise.all([
                    ExchangeConfig(),
                    SolanaComputeFeePrice()
                ]);
                console.log("-------navigator.userAgent--------", navigator.userAgent);
            } catch (error) {
                console.error("初始化失败:", error);
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
        // 监听全局输入框聚焦状态
        const handleFocus = (e)=>{
            if (e.target.tagName === "INPUT") {
                setIsInputFocused(true);
            }
        };
        const handleBlur = (e)=>{
            if (e.target.tagName === "INPUT") {
                setIsInputFocused(false);
            }
        };
        document.addEventListener("focusin", handleFocus);
        document.addEventListener("focusout", handleBlur);
        return ()=>{
            document.removeEventListener("focusin", handleFocus);
            document.removeEventListener("focusout", handleBlur);
        };
    }, []);
    useEffect(()=>{
        if (!address) return;
        const currentAddress = chainType != "ton" ? address : (chainObj === null || chainObj === void 0 ? void 0 : chainObj.ton) ? chainObj.ton : address === null || address === void 0 ? void 0 : address.unbounceable;
        setfromAddress(currentAddress);
        setEventData({
            ...EventData,
            address: currentAddress
        });
    }, [
        address,
        chainType
    ]);
    useEffect(()=>{
        const selectedChain = fromTokenList.filter((item)=>item.chain === chainType)[0];
        if (selectedChain) {
            setfromToken(selectedChain);
            // 选择不同链,输入框清零
            if (fromToken.chain !== selectedChain.chain) {
                resetSwapData();
            }
        }
        setIsButtonLoading(false);
    }, [
        switchCount
    ]);
    const getlistExchangeOrder = async (params)=>{
        if (!token) {
            return false;
        }
        try {
            const { address, page, limit } = params;
            const res = await listExchangeOrder.fetcher({
                address,
                page,
                limit
            });
            const { data, status } = res;
            if (status == 0 && (data === null || data === void 0 ? void 0 : data.list)) {
                const resList = (data === null || data === void 0 ? void 0 : data.list) || [];
                setRecords([
                    ...resList
                ]);
            } else {
                toast({
                    variant: "error",
                    title: data || "order server error",
                    duration: 3000
                });
            }
        } catch (error) {
            console.log("getlistExchangeOrder error:", error);
        }
    };
    const getbwbBalance = async (chainObj)=>{
        if (!chainObj) {
            return false;
        }
        try {
            const list = fromTokenList.map((item)=>{
                return {
                    chain: item.chain,
                    address: chainObj[item.chain],
                    contract: [
                        item.contract
                    ]
                };
            });
            const res = await batchV2.fetcher({
                list
            });
            const { data, status, msg } = res;
            if (status == 0 && data && msg == "Success") {
                const batchV2 = data;
                const fromList = fromTokenList.map((token)=>{
                    const itemToken = batchV2.filter((item)=>{
                        return item.address === chainObj[item.chain] && item.chain === token.chain;
                    });
                    if (itemToken[0]) {
                        var _Object_values_, _Object_values_1;
                        const balance = ((_Object_values_ = Object.values(itemToken[0].list)[0]) === null || _Object_values_ === void 0 ? void 0 : _Object_values_.balance) || 0;
                        const price = ((_Object_values_1 = Object.values(itemToken[0].list)[0]) === null || _Object_values_1 === void 0 ? void 0 : _Object_values_1.price) || 0;
                        token.balance = balance;
                        token.balanceTousd = floor(balance * price, 4);
                    }
                    return token;
                });
                setfromTokenList([
                    ...fromList
                ]);
                const selectChainIndex = fromToken.chain ? fromList.findIndex((item)=>item.chain === fromToken.chain) : 0;
                setfromToken(fromList[selectChainIndex]);
            } else {
                toast({
                    variant: "error",
                    title: msg || "balance server error",
                    duration: 3000
                });
            }
        } catch (error) {
            console.log("getbwbBalance error:", error);
        }
    };
    useEffect(()=>{
        if (isReady && bitkeep && isBitkeep && appHeaderReady) {
            const init = async ()=>{
                try {
                    bitkeep.setTitle(t("swapToken", {
                        coin1: "BWB",
                        coin2: "BGB"
                    }));
                    if (chainObj) {
                        settoAddress((chainObj === null || chainObj === void 0 ? void 0 : chainObj.eth) || (chainObj === null || chainObj === void 0 ? void 0 : chainObj.bnb) || (chainObj === null || chainObj === void 0 ? void 0 : chainObj.morph));
                        getbwbBalance(chainObj);
                    }
                    if (!token) return;
                    getlistExchangeOrder({
                        address: (chainObj === null || chainObj === void 0 ? void 0 : chainObj.eth) || (chainObj === null || chainObj === void 0 ? void 0 : chainObj.bnb) || (chainObj === null || chainObj === void 0 ? void 0 : chainObj.morph),
                        page: 1,
                        limit: 1000
                    });
                    handleConnect(fromToken.chain, "init");
                    const { success, data } = await bitkeep.getWalletInfo();
                    if (success) {
                        setWalletInfo({
                            ...data
                        });
                        setEventData({
                            ...EventData,
                            wallet_tag: data.walletType,
                            wallet_type: data.walletType
                        });
                    }
                    setIsButtonLoading(false);
                } catch (err) {
                    setIsButtonLoading(false);
                    console.error("BitKeep Error:", err);
                }
            };
            init();
        }
    }, [
        isReady,
        isBitkeep,
        bitkeep,
        error,
        token,
        chainObj,
        appHeaderReady
    ]);
    const handleBlur = ()=>{
        if (bwbAmount === "") {
            setbwbAmount("0"); // 如果没有输入，则恢复默认值
        } else {
            const validation = validateInput(bwbAmount);
            // 更新验证状态
            setValidationState({
                isValid: validation.isValid,
                errorKey: validation.errorKey,
                errorParams: validation.errorParams
            });
            // 如果输入值小于最小值或大于最大值，设置为最小值或最大值
            const numericValue = parseFloat(bwbAmount);
            // if (numericValue > maxLimitAmount) {
            //   setbwbAmount(maxLimitAmount.toString());
            // } else if (numericValue < minAmountPerTx) {
            //   setbwbAmount(minAmountPerTx.toString());
            // } else {
            // }
            setbwbAmount(numericValue.toString());
        }
    };
    const getErrorMessage = (errorKey, t, params)=>{
        switch(errorKey){
            case "minSellAmount":
                return t("minSellAmount", {
                    num: Number(params.minAmountPerTx)
                });
            case "maxSellAmount":
                return t("maxSellAmount", {
                    num: Number(params.maxAmountPerTx)
                });
            case "insufficientBalance":
                return t("insufficientBalance");
            case "quotaExhausted":
                return t("quotaExhausted", {
                    coin: "BGB"
                });
            default:
                console.warn("Unknown error key: ".concat(errorKey));
                return "";
        }
    };
    const handleBwbAmountChange = (event)=>{
        const { value } = event.target;
        // 正则表达式：匹配有效的金额格式，允许小数点后最多9位
        const regex = /^(0|[1-9]\d*)(\.\d{0,2})?$/;
        let correctedValue;
        if (regex.test(value) || value === "") {
            // 如果输入符合条件，更新状态
            correctedValue = value;
        } else {
            // 自动纠正输入
            correctedValue = value.replace(/[^0-9.]+/g, "") // 只保留数字和小数点
            .replace(/(\..*?)\..*/g, "$1") // 确保只保留第一个小数点
            .replace(/^0(?!\.)/, ""); // 不允许以0开头（除了0.的情况）
        }
        // 处理小数部分最多两位
        const parts = correctedValue.split(".");
        if (parts[1] && parts[1].length > 8) {
            parts[1] = parts[1].slice(0, 8); // 限制小数部分最多两位
        }
        const finalValue = parts.join(".");
        setbwbAmount(finalValue);
        clearValidation();
    };
    const handleMaxAmount = ()=>{
        if ((exchangeConfig === null || exchangeConfig === void 0 ? void 0 : exchangeConfig.EXCHANGE_RATE) == 0) {
            return false;
        }
        // 获取当前余额
        const maxAmount = fromToken.balance || "0";
        // 验证是否在允许范围内
        const amount = maxAmount.toString();
        // 触发onChange事件以确保验证状态更新
        handleBwbAmountChange({
            target: {
                value: amount
            }
        });
        const validation = validateInput(amount);
        // 更新验证状态
        setValidationState({
            isValid: validation.isValid,
            errorKey: validation.errorKey,
            errorParams: validation.errorParams
        });
    };
    const resetSwapData = ()=>{
        setbwbAmount("0");
        clearValidation();
    // setReceiveAmount(0);
    };
    const announcement = ()=>{
        const announcementUrl = "https://web3.bitget.com/".concat(locale == "zh" || locale == "zh-CN" ? "zh-CN" : "en", "/blog/articles/bwb-and-bgb-token-merge-upgrade");
        if (!isBitkeep) {
            openSafeWindow(announcementUrl, "_blank");
        } else {
            bitkeep.jumpUrl(announcementUrl);
        }
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "w-full min-h-screen flex flex-col overflow-y-auto scroll-smooth",
                style: {
                    maxWidth: "560px",
                    background: "url(".concat(CommonImages.BG.src, ") center/cover,").concat(document.documentElement.getAttribute("data-theme") === "dark" ? "linear-gradient(180deg, #6850D7 -2.46%, #3D9AD1 31.69%, #5454B1 65.85%, #15162A 100%)" : "linear-gradient(180deg, #DDE0FF 0%, #FFF 100%)")
                },
                children: [
                    /*#__PURE__*/ _jsx(AppOpenBanner, {
                        utmSource: "bwbSwapBgb"
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "sticky ".concat(isBitkeep ? "top-[0px]" : "top-[44px]", " z-999 w-full px-[20px] py-[8px] bg-[var(--bt-colorGreen3)] text-[14px] text-[#00C2B7] flex items-center justify-between"),
                        onClick: announcement,
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex",
                                children: [
                                    /*#__PURE__*/ _jsxs("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "20",
                                        height: "20",
                                        viewBox: "0 0 20 20",
                                        fill: "none",
                                        className: "mr-[8px]",
                                        children: [
                                            /*#__PURE__*/ _jsx("path", {
                                                d: "M12.4801 4.2718C12.3884 4.2718 12.3009 4.25514 12.2093 4.22597C11.7759 4.07597 11.5426 3.60097 11.6926 3.16764L12.0134 2.23014C12.1634 1.7968 12.6343 1.56347 13.0718 1.71347C13.5051 1.86347 13.7384 2.33847 13.5884 2.7718L13.2676 3.7093C13.1509 4.05514 12.8259 4.2718 12.4801 4.2718Z",
                                                fill: "#00C2B7"
                                            }),
                                            /*#__PURE__*/ _jsx("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M5.86761 3.2593C6.55094 2.57597 7.65511 2.4718 8.97594 2.9718C10.0801 3.38847 11.2676 4.1968 12.3218 5.25097C14.7343 7.6593 15.5884 10.4385 14.3176 11.7093C14.0843 11.9468 13.7884 12.101 13.4676 12.1926V12.2051L10.2009 13.3093C10.4093 14.251 10.5843 15.7468 9.94678 16.8176C9.56761 17.4593 8.95094 17.8676 8.16344 17.9968C7.98011 18.026 7.80511 18.0426 7.63844 18.0426C5.90511 18.0426 4.86761 16.5218 4.38428 15.2343C4.30094 15.2468 4.22178 15.251 4.13844 15.251C3.57594 15.251 3.04261 15.0218 2.64261 14.5968C2.12594 14.0468 1.95511 13.2885 2.18011 12.5676L2.19678 12.5218L5.36761 4.1468C5.45928 3.80514 5.62178 3.50514 5.86761 3.2593ZM3.76761 13.0843C3.71344 13.276 3.81344 13.4093 3.85928 13.4593H3.86344C3.90928 13.5093 4.03428 13.6135 4.22178 13.5801L10.2468 11.5385C9.45511 11.1051 8.67594 10.5301 7.86344 9.71764C7.05094 8.90514 6.42178 8.05514 5.98428 7.23014L3.76761 13.0843ZM7.88844 16.3551C8.27594 16.2885 8.42594 16.1135 8.51344 15.9676H8.50928C8.80094 15.4801 8.75094 14.601 8.60511 13.8468L5.98011 14.7343C6.27178 15.4801 6.86761 16.526 7.88844 16.3551ZM12.9343 10.6343C13.0218 10.6135 13.0926 10.5801 13.1384 10.5343H13.1426C13.5134 10.1635 13.0384 8.32597 11.1468 6.4343C10.2676 5.5593 9.26344 4.86347 8.38844 4.5343C8.00094 4.38847 7.68428 4.33014 7.45094 4.33014C7.25094 4.33014 7.11344 4.3718 7.04678 4.43847C6.67594 4.8093 7.15094 6.6468 9.04261 8.53847C10.6843 10.1843 12.2843 10.7551 12.9218 10.6343H12.9343Z",
                                                fill: "#00C2B7"
                                            }),
                                            /*#__PURE__*/ _jsx("path", {
                                                d: "M16.3593 4.5843L17.0509 3.87597C17.3718 3.5468 17.3676 3.01764 17.0384 2.6968C16.7093 2.37597 16.1843 2.38014 15.8593 2.7093L15.1676 3.41764C14.8468 3.7468 14.8509 4.27597 15.1801 4.5968C15.3426 4.75514 15.5509 4.8343 15.7634 4.8343C15.9759 4.8343 16.1968 4.75097 16.3593 4.5843Z",
                                                fill: "#00C2B7"
                                            }),
                                            /*#__PURE__*/ _jsx("path", {
                                                d: "M16.9176 6.1718C17.3384 5.99263 17.8301 6.18846 18.0093 6.61346C18.1884 7.03846 17.9926 7.52596 17.5676 7.70513L16.6551 8.09263C16.5468 8.13846 16.4384 8.1593 16.3301 8.1593C16.0051 8.1593 15.6968 7.96763 15.5634 7.65096C15.3843 7.22596 15.5801 6.73846 16.0051 6.5593L16.9176 6.1718Z",
                                                fill: "#00C2B7"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        children: t("bwbWelfareCenter_announcement")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "7",
                                height: "12",
                                viewBox: "0 0 7 12",
                                fill: "none",
                                children: /*#__PURE__*/ _jsx("path", {
                                    d: "M1 1L6 6L1 11",
                                    stroke: "#00C2B7",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex-1 px-[20px] pt-[16px] pb-[150px]",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "mb-[35px] flex justify-between items-center",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "",
                                        children: [
                                            /*#__PURE__*/ _jsx("h1", {
                                                className: "text-[32px] font-bold text-[var(--text-1)]",
                                                children: t("swapToken", {
                                                    coin1: "BWB",
                                                    coin2: "BGB"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsxs("p", {
                                                className: "text-[13px] font-medium text-[var(--text-1)]",
                                                children: [
                                                    t("swapRate"),
                                                    "：1 BWB = ",
                                                    exchangeConfig === null || exchangeConfig === void 0 ? void 0 : exchangeConfig.EXCHANGE_RATE,
                                                    " BGB"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(Image, {
                                        width: 80,
                                        height: 83,
                                        src: CommonImages.bitgetWallet_Icon.src,
                                        alt: "bitgetWallet_Icon",
                                        className: "mr-[10px]"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "bg-[var(--bg-0)] rounded-[8px] px-[16px] py-[13px] mb-[10px] flex items-center justify-between",
                                onClick: ()=>!fromAddress ? handleConnect(fromToken.chain) : switchWallet(),
                                children: [
                                    !fromAddress && /*#__PURE__*/ _jsx("span", {
                                        className: "text-[13px] text-[var(--text-1)] font-medium",
                                        children: t("connectWallet")
                                    }),
                                    fromAddress && /*#__PURE__*/ _jsxs("div", {
                                        className: "flex flex-col",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "w-[200px] text-[13px] text-[var(--text-1)] font-medium truncate overflow-hidden whitespace-nowrap",
                                                children: WalletInfo === null || WalletInfo === void 0 ? void 0 : WalletInfo.walletName
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "text-[12px] text-[var(--text-4)] font-normal",
                                                children: formatAddress(fromAddress)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "16",
                                        height: "16",
                                        viewBox: "0 0 16 16",
                                        fill: "none",
                                        children: /*#__PURE__*/ _jsx("path", {
                                            d: "M10.7809 7.33327L7.2049 3.75726L8.1477 2.81445L13.3332 7.99993L8.1477 13.1853L7.2049 12.2425L10.7809 8.6666H2.6665V7.33327H10.7809Z",
                                            fill: "#00C2B7"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "bg-[var(--bg-0)] rounded-[8px] px-[16px] py-[15px]",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "flex justify-between mb-[13px]",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "text-[12px] text-[var(--text-4)]",
                                                        children: t("swapFrom")
                                                    }),
                                                    /*#__PURE__*/ _jsxs("span", {
                                                        className: "text-[12px] text-[var(--text-3)] flex items-center",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs("svg", {
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                width: "11",
                                                                height: "11",
                                                                viewBox: "0 0 11 11",
                                                                fill: "none",
                                                                className: "block mr-[4px]",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("path", {
                                                                        d: "M5.5 5.85156C5.5 5.02314 6.17157 4.35156 7 4.35156H10.5V7.35156H7C6.17157 7.35156 5.5 6.67999 5.5 5.85156Z",
                                                                        stroke: "#A4AEAE"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("rect", {
                                                                        x: "0.5",
                                                                        y: "1.35156",
                                                                        width: "10",
                                                                        height: "9",
                                                                        rx: "0.5",
                                                                        stroke: "#A4AEAE"
                                                                    })
                                                                ]
                                                            }),
                                                            fromToken.balance || 0,
                                                            /*#__PURE__*/ _jsx("svg", {
                                                                className: "mx-[6px]",
                                                                width: "2",
                                                                height: "12",
                                                                viewBox: "0 0 2 12",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: /*#__PURE__*/ _jsx("path", {
                                                                    d: "M0.424 12.0036V0.891562H1.588V12.0036H0.424Z",
                                                                    fill: "#A4AEAE"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("span", {
                                                                className: "text-[#00C2B7] text-[11px]",
                                                                onClick: handleMaxAmount,
                                                                children: t("All")
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "flex items-center justify-between",
                                                children: [
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "flex items-center",
                                                        onClick: ()=>{
                                                            reloadData();
                                                            openSelectToken("from");
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "w-8 h-8 relative mr-[8px]",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Image, {
                                                                        src: fromToken.coinIcon,
                                                                        alt: fromToken.symbol,
                                                                        fill: true,
                                                                        className: "rounded-full"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Image, {
                                                                        width: 16,
                                                                        height: 16,
                                                                        src: fromToken.chainIcon,
                                                                        alt: fromToken.chainName,
                                                                        className: "rounded-full absolute right-[-5px] bottom-[-2px]"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsx("span", {
                                                                className: "font-bold text-[16px] text-[var(--text-1)] mr-[8px]",
                                                                children: fromToken.symbol
                                                            }),
                                                            /*#__PURE__*/ _jsxs("svg", {
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                width: "20",
                                                                height: "21",
                                                                viewBox: "0 0 20 21",
                                                                fill: "none",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("g", {
                                                                        clipPath: "url(#clip0_54513_14850)",
                                                                        children: /*#__PURE__*/ _jsx("path", {
                                                                            d: "M10.0001 11.8281L14.1251 7.70312L15.3034 8.88146L10.0001 14.1848L4.69678 8.88146L5.87511 7.70312L10.0001 11.8281Z",
                                                                            fill: "var(--text-1)"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("defs", {
                                                                        children: /*#__PURE__*/ _jsx("clipPath", {
                                                                            id: "clip0_54513_14850",
                                                                            children: /*#__PURE__*/ _jsx("rect", {
                                                                                width: "20",
                                                                                height: "20",
                                                                                fill: "white",
                                                                                transform: "translate(0 0.851562)"
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "flex-1 h-[40px] text-right",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("input", {
                                                                disabled: isloading,
                                                                autoComplete: "off",
                                                                placeholder: t("inputAmount"),
                                                                autoCorrect: "off",
                                                                inputMode: "decimal",
                                                                spellCheck: false,
                                                                enterKeyHint: "next",
                                                                value: bwbAmount,
                                                                type: "number",
                                                                autoCapitalize: "off",
                                                                onFocus: ()=>{
                                                                    if (bwbAmount === "0") {
                                                                        setbwbAmount(""); // 清空默认值
                                                                    }
                                                                },
                                                                onBlur: handleBlur,
                                                                onChange: handleBwbAmountChange,
                                                                style: {
                                                                    // 防止 iOS 缩放
                                                                    WebkitTextSizeAdjust: "100%",
                                                                    // 禁用长按菜单
                                                                    WebkitTouchCallout: "none"
                                                                },
                                                                className: "inline-block max-w-[200px] h-[30px] ml-10px appearance-none font-medium text-[16px] text-[var(--text-1)] text-right outline-none placeholder:text-[var(--text-4)] bg-[var(--bg-0)] placeholder:font-normal"
                                                            }),
                                                            !validationState.isValid && validationState.errorKey && /*#__PURE__*/ _jsx("span", {
                                                                className: "block text-[11px] text-[#FE5B79] font-normal",
                                                                children: getErrorMessage(validationState.errorKey, t, {
                                                                    minAmountPerTx,
                                                                    maxAmountPerTx
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "flex justify-center",
                                        children: /*#__PURE__*/ _jsx("div", {
                                            className: "w-10 h-10 bg-[var(--bg-0)] rounded-full flex items-center justify-center shadow-sm",
                                            children: /*#__PURE__*/ _jsx("svg", {
                                                className: "w-6 h-6",
                                                fill: "none",
                                                stroke: "var(--text-1)",
                                                viewBox: "0 0 24 24",
                                                children: /*#__PURE__*/ _jsx("path", {
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round",
                                                    strokeWidth: 2,
                                                    d: "M19 14l-7 7m0 0l-7-7m7 7V3"
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "mb-[6px]",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex justify-between mb-[13px]",
                                                children: /*#__PURE__*/ _jsx("span", {
                                                    className: "text-[12px] text-[var(--text-4)]",
                                                    children: t("swapTo")
                                                })
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "flex items-center justify-between",
                                                children: [
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "flex items-center",
                                                        onClick: ()=>openSelectToken("to"),
                                                        children: [
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "w-8 h-8 relative mr-[8px]",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx(Image, {
                                                                        src: toToken.coinIcon,
                                                                        alt: toToken.symbol,
                                                                        fill: true,
                                                                        className: "rounded-full"
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Image, {
                                                                        width: 16,
                                                                        height: 16,
                                                                        src: toToken.chainIcon,
                                                                        alt: toToken.chainName,
                                                                        className: "rounded-full absolute right-[-5px] bottom-[-2px]"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsx("span", {
                                                                className: "font-bold text-[16px] text-[var(--text-1)] mr-[8px]",
                                                                children: toToken.symbol
                                                            }),
                                                            /*#__PURE__*/ _jsxs("svg", {
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                width: "20",
                                                                height: "21",
                                                                viewBox: "0 0 20 21",
                                                                fill: "none",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("g", {
                                                                        clipPath: "url(#clip0_54513_14850)",
                                                                        children: /*#__PURE__*/ _jsx("path", {
                                                                            d: "M10.0001 11.8281L14.1251 7.70312L15.3034 8.88146L10.0001 14.1848L4.69678 8.88146L5.87511 7.70312L10.0001 11.8281Z",
                                                                            fill: "var(--text-1)"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("defs", {
                                                                        children: /*#__PURE__*/ _jsx("clipPath", {
                                                                            id: "clip0_54513_14850",
                                                                            children: /*#__PURE__*/ _jsx("rect", {
                                                                                width: "20",
                                                                                height: "20",
                                                                                fill: "white",
                                                                                transform: "translate(0 0.851562)"
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "font-medium text-[var(--text-1)]",
                                                        children: receiveAmount == 0 ? 0.0 : receiveAmount
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "mt-10px",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex items-center justify-between py-[10px] font-normal text-[13px]",
                                        children: [
                                            /*#__PURE__*/ _jsxs("label", {
                                                className: "text-[var(--text-2)]",
                                                children: [
                                                    t("gasFee"),
                                                    "（BGB）"
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "text-[var(--text-1)]",
                                                children: toToken.chain == "eth" ? exchangeConfig === null || exchangeConfig === void 0 ? void 0 : exchangeConfig.BGB_SEND_GAS_ETH : (exchangeConfig === null || exchangeConfig === void 0 ? void 0 : exchangeConfig.BGB_SEND_GAS_MORPH) || 0
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex items-center justify-between py-[10px] font-normal text-[13px]",
                                        children: [
                                            /*#__PURE__*/ _jsxs("label", {
                                                className: " text-[var(--text-2)]",
                                                children: [
                                                    t("estimatedAmount"),
                                                    "（BGB）"
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "text-[var(--text-1)]",
                                                children: receiveAmount == 0 ? 0 : subtract(receiveAmountNumber, toToken.chain == "eth" ? exchangeConfig === null || exchangeConfig === void 0 ? void 0 : exchangeConfig.BGB_SEND_GAS_ETH : exchangeConfig === null || exchangeConfig === void 0 ? void 0 : exchangeConfig.BGB_SEND_GAS_MORPH)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(FAQ, {
                                className: "mt-34px"
                            }),
                            /*#__PURE__*/ _jsx(TutorialLink, {
                                className: "mt-24px block text-center"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "  \n        max-w-[400px] mx-auto fixed bottom-0 left-0 right-0   \n        p-4 pb-8 bg-[var(--bg-0)] backdrop-blur-[10px] bg-white/30   \n        flex items-center justify-between  \n        transition-all duration-300 ease-in-out  \n        ".concat(isInputFocused ? "translate-y-full" : "translate-y-0", "  \n      "),
                        children: [
                            !isBitkeep && /*#__PURE__*/ _jsx(Button, {
                                fullWidth: true,
                                onClick: handleOpenApp,
                                className: "text-[16px] h-[54px] BTstyle",
                                children: t("openInBitgetWallet")
                            }),
                            isBitkeep && !fromAddress && /*#__PURE__*/ _jsx(Button, {
                                isLoading: isButtonLoading,
                                fullWidth: true,
                                onClick: ()=>handleConnect(fromToken.chain),
                                className: "text-[16px] h-[54px] BTstyle",
                                children: t("connectWallet")
                            }),
                            isBitkeep && fromAddress && /*#__PURE__*/ _jsxs("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "28",
                                height: "28",
                                viewBox: "0 0 28 28",
                                fill: "none",
                                onClick: ()=>{
                                    reloadData();
                                    setIsOpenSwapHistory(true);
                                },
                                children: [
                                    /*#__PURE__*/ _jsx("path", {
                                        d: "M2.625 4.08268C2.625 2.9551 3.53909 2.04102 4.66667 2.04102H21C22.1276 2.04102 23.0417 2.9551 23.0417 4.08268V12.8327C23.0417 13.3159 22.6499 13.7077 22.1667 13.7077C21.6834 13.7077 21.2917 13.3159 21.2917 12.8327V4.08268C21.2917 3.9216 21.1611 3.79102 21 3.79102H4.66667C4.50558 3.79102 4.375 3.9216 4.375 4.08268V23.3327C4.375 23.4938 4.50558 23.6243 4.66667 23.6243H11.6667C12.1499 23.6243 12.5417 24.0161 12.5417 24.4993C12.5417 24.9826 12.1499 25.3744 11.6667 25.3744H4.66667C3.53909 25.3744 2.625 24.4603 2.625 23.3327V4.08268ZM7.57209 7.58268C7.57209 7.09943 7.96384 6.70768 8.44709 6.70768H16.0304C16.5137 6.70768 16.9054 7.09943 16.9054 7.58268C16.9054 8.06593 16.5137 8.45768 16.0304 8.45768H8.44709C7.96384 8.45768 7.57209 8.06593 7.57209 7.58268ZM7.57209 12.8327C7.57209 12.3494 7.96384 11.9577 8.44709 11.9577H13.1138C13.597 11.9577 13.9888 12.3494 13.9888 12.8327C13.9888 13.3159 13.597 13.7077 13.1138 13.7077H8.44709C7.96384 13.7077 7.57209 13.3159 7.57209 12.8327ZM19.25 17.2077C18.7668 17.2077 18.375 17.5994 18.375 18.0827V20.3642C18.375 20.6295 18.4804 20.8838 18.6679 21.0713L20.3813 22.7847C20.723 23.1264 21.277 23.1264 21.6187 22.7847C21.9604 22.443 21.9604 21.889 21.6187 21.5473L20.125 20.0536V18.0827C20.125 17.5994 19.7332 17.2077 19.25 17.2077Z",
                                        fill: "var(--text-1)"
                                    }),
                                    /*#__PURE__*/ _jsx("path", {
                                        d: "M19.25 24.4993C16.9948 24.4993 15.1667 22.6712 15.1667 20.416C15.1667 18.1609 16.9948 16.3327 19.25 16.3327C21.5052 16.3327 23.3333 18.1609 23.3333 20.416C23.3333 22.6712 21.5052 24.4993 19.25 24.4993ZM19.25 26.2494C22.4717 26.2494 25.0833 23.6377 25.0833 20.416C25.0833 17.1944 22.4717 14.5827 19.25 14.5827C16.0283 14.5827 13.4167 17.1944 13.4167 20.416C13.4167 23.6377 16.0283 26.2494 19.25 26.2494Z",
                                        fill: "var(--text-1)"
                                    })
                                ]
                            }),
                            isBitkeep && fromAddress && /*#__PURE__*/ _jsx(Button, {
                                isLoading: isButtonLoading,
                                fullWidth: true,
                                onClick: ()=>swap(),
                                className: "text-[16px] h-[54px] BTstyle ml-[25px]",
                                disabled: bwbAmount == "0" || !bwbAmount || !validationState.isValid,
                                children: t("swap")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(SelectToken, {
                data: selectTokenType == "from" ? fromTokenList : toTokenList,
                open: isOpenselectToken,
                onClose: ()=>setIsOpenselectToken(false),
                onChange: handleTokenSelect,
                defaultValue: selectTokenType == "from" ? fromToken : toToken,
                walletType: WalletInfo.walletType
            }),
            /*#__PURE__*/ _jsx(SwapHistory, {
                data: records,
                open: isOpenSwapHistory,
                onClose: ()=>setIsOpenSwapHistory(false)
            }),
            /*#__PURE__*/ _jsx(SwapResult, {
                status: swapResultStatus,
                address: toAddress,
                onClose: ()=>setIsOpenSwapResult(false),
                onBack: ()=>{
                    setIsOpenSwapResult(false);
                    swapResultStatus && setIsOpenSwapHistory(true);
                },
                open: isOpenSwapResult
            })
        ]
    });
};
export default SwapContent;
